import { z } from 'zod';

import type { Guid } from '@apple/utils/primitive';

import {
	type ProductListingModel,
	productListingModelSchema,
} from '@apple/features/product/models/product';

import { type StoreEventCategory, storeEventCategorySchema } from '../models/categories';

/** @see AppleRetail.Web.Areas.StoreEvents.ApiControllers.StoreEventCategoryApiController.StoreEventItemConflictModel */
export interface StoreEventItemConflictModel {
	storeEventItemId: Guid;
	storeEventCategoryId: Guid;
	product: ProductListingModel;
	isManualAdd: boolean;
	productItemId: string;
	existingQuantity: number | null;
	newQuantity: number | null;
}

/** @see AppleRetail.Web.Areas.StoreEvents.ApiControllers.StoreEventCategoryApiController.StoreEventItemConflictGroupModel */
export interface StoreEventItemConflictGroupModel {
	category: StoreEventCategory;
	conflicts: StoreEventItemConflictModel[];
}

/** @see AppleRetail.Web.Areas.StoreEvents.ApiControllers.StoreEventCategoryApiController.StoreEventItemConflictModel */
export const storeEventItemConflictModelSchema = z.object({
	storeEventItemId: z.string(),
	storeEventCategoryId: z.string(),
	product: productListingModelSchema,
	isManualAdd: z.boolean(),
	productItemId: z.string(),
	existingQuantity: z.number().nullable(),
	newQuantity: z.number().nullable(),
}) satisfies z.ZodType<StoreEventItemConflictModel>;

/** @see AppleRetail.Web.Areas.StoreEvents.ApiControllers.StoreEventCategoryApiController.StoreEventItemConflictGroupModel */
export const storeEventItemConflictGroupModelSchema = z.object({
	category: storeEventCategorySchema,
	conflicts: storeEventItemConflictModelSchema.array(),
}) satisfies z.ZodType<StoreEventItemConflictGroupModel>;
